import { render, staticRenderFns } from "./k-catalog.vue?vue&type=template&id=ed6232bc&scoped=true&"
import script from "./k-catalog.vue?vue&type=script&lang=ts&"
export * from "./k-catalog.vue?vue&type=script&lang=ts&"
import style0 from "./k-catalog.vue?vue&type=style&index=0&id=ed6232bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6232bc",
  null
  
)

export default component.exports